import { useEffect, useState } from "react"
import { getProgramsWithOverallScoreRange } from "../helpers"

export const useProgramsWithOverallScoreRange = (
  disableFetching: boolean,
  useGraphQL = false
) => {
  const [programsWithOverallScoreRange, setProgramsWithOverallScoreRange] =
    useState<string[]>([])
  const [
    programsWithOverallScoreRangeLoading,
    setProgramsWithOverallScoreRangeLoading
  ] = useState<boolean>(false)

  useEffect(() => {
    const fetchProgramsWithOverall = async () => {
      setProgramsWithOverallScoreRangeLoading(true)

      try {
        const response = await getProgramsWithOverallScoreRange(useGraphQL)

        setProgramsWithOverallScoreRange(response)
      } catch (error) {
        console.warn("[ReportingContext]", error)
      } finally {
        setProgramsWithOverallScoreRangeLoading(false)
      }
    }

    if (!disableFetching) {
      fetchProgramsWithOverall()
    }
  }, [disableFetching, useGraphQL])

  return {
    programsWithOverallScoreRange,
    programsWithOverallScoreRangeLoading
  }
}
